import React, { DependencyList } from 'react';

type Callback = () => void | (() => void | undefined);

export const useDidUpdate = (callback: Callback, depArray: DependencyList) => {
  const initRef = React.useRef<boolean | null>(null);

  React.useEffect(() => {
    let returnedValue = null;

    if (!initRef.current) {
      initRef.current = true;
    } else {
      returnedValue = callback();
    }
    if (returnedValue) {
      return returnedValue();
    }
  }, depArray);
};
